import { FC } from "react";
import { Flex } from "@chakra-ui/react";
import { sharedProps } from "~/constants";
import { useCurrentUser } from "~/hooks/useCurrentUser";
import { useLocationType } from "~/hooks/useLocationType";
import { LandingAppOnlySection } from "./LandingAppOnlySection";
import { RequiredLinks } from "./RequiredLinks";

export const Footer: FC = () => {
  const locationType = useLocationType();
  const user = useCurrentUser();
  const landingAppOnly = locationType === "landingApp" && !user;

  return (
    <Flex
      align="center"
      as="footer"
      bg="fg-accent"
      direction="column"
      justify="center"
      py={8}
      {...sharedProps.fullBleed}
    >
      <Flex
        flexDirection="column"
        justify="center"
        {...sharedProps.max.content}
      >
        {landingAppOnly && <LandingAppOnlySection />}
        <RequiredLinks />
      </Flex>
    </Flex>
  );
};
